<template>
  <div>
    <div class="form-group">
      <label class="is-required">Tipe produk</label>
      <select class="form-control" placeholder="Pilih tipe" v-model="hobby" required @change="reset" name="product_hobby_id">
        <option hidden value="">Pilih tipe</option>
        <option v-for="hobby in hobbies" :value="hobby.id" :key="hobby.id">{{ hobby.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="is-required">Kategori</label>
      <select class="form-control" placeholder="Pilih kategori" v-model="category" required name="product_category_id">
        <option hidden value="">Pilih kategori</option>
        <option v-for="category in filteredCategories" :value="category.id" :key="category.id">{{ category.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label>Sub kategori</label>
      <select class="form-control" placeholder="Opsional" v-model="subCategory" name="product_sub_category_id">
        <option hidden value="">Opsional</option>
        <option v-for="subCategory in filteredSubCategories" :value="subCategory.id" :key="subCategory.id">{{ subCategory.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hobbies: {
      type: Array,
      default: []
    },
    categories: {
      type: Array,
      default: []
    },
    subCategories: {
      type: Array,
      default: []
    },
    selectedHobby: {
      type: String,
      required: false
    },
    selectedCategory: {
      type: String,
      required: false
    },
    selectedSubCategory: {
      type: String,
      required: false
    }
  },
  methods: {
    reset(){
      this.category = null
      this.subCategory = null
    }
  },
  mounted(){
    if(this.selectedHobby != '') {
      this.hobby = parseInt(this.selectedHobby)
    }
    if(this.selectedCategory != '') {
      this.category = parseInt(this.selectedCategory)
    }
    if(this.selectedSubCategory != '') {
      this.subCategory = parseInt(this.selectedSubCategory)
    }
  },
  data(){
    return {
      hobby: null,
      category: null,
      subCategory: null,
    }
  },
  computed: {
    filteredCategories() {
      if(this.hobby) {
        return this.categories.filter(c => c.hobby_id === this.hobby)
      }
      return []
    },
    filteredSubCategories() {
      if(this.category) {
        return this.subCategories.filter(sc => sc.category_id === this.category)
      }
      return []
    }
  }
}
</script>